import { createSelector } from 'reselect'

const getQuestionsListings = (state: any) => state.questionsListings

/** A Redux selector to retrieve Questions count
 * @param state - The Redux state
 * @param {object} - Questions Listings data.
 */

export const selectQuestionsListings = createSelector(
  getQuestionsListings,
  (data) => data && data.questionsListings ? data.questionsListings : null
)

/** A Redux selector to retrieve Latest Questions List Is Loading state
 * @param state - The Redux state
 * @param {Boolean} - Fetching Latest Question list Is Loading
 */

export const selectQuestionsListIsLoading = createSelector(
  getQuestionsListings,
  (data) => data && data.status ? data.status.isLoading : null
)
